import * as yup from "yup";
// const passwordRules = /^(?=.*\d) (?=.*[a-z]) (?=.*[A-Z]).{5,}$/;
// min 5 Characters, 1 upper case letter, 1 lower case letter, 1 numeric digit
export const contactSchema = yup.object().shape({
  email: yup.string().email(),
  name: yup.string().required(),
  phone: yup.number().required(),
  message: yup.string(),
});
